export const DEFAULT_PAYROLL_SUBMITTING = {
  records: 0,
  submitted: 0,
  success: 0,
  error: 0,
  loading: false,
  errorRecords: [],
};
